import { ApiRequestService } from "services/ApiRequestService";

// File extracts are owned by the microservice that holds the files, so every call takes the
// microservice key alongside the payload. The endpoint shapes are identical per service.
export const FileExtractService = {
    requestExtract(microserviceKey, request) {
        return ApiRequestService.post(microserviceKey, "FileExtracts", request);
    },
    searchExtracts(microserviceKey, searchRequest) {
        return ApiRequestService.post(microserviceKey, "FileExtracts/Search", searchRequest);
    },
    getExtract(microserviceKey, id) {
        return ApiRequestService.get(microserviceKey, `FileExtracts/${id}`);
    },
    getPartDownloadToken(microserviceKey, extractId, partId) {
        return ApiRequestService.get(microserviceKey, `FileExtracts/${extractId}/Parts/${partId}/DownloadToken`);
    }
};
